export default {
  brand: {
    primary: '#0A001E',
    secondary: '#89E100',
    tertiary: '#8050F2',
    quaternary: '#D0D0D0',
  },
};
